import React, { memo } from 'react'
import { InlineMessage } from 'transfix-ui/components/InlineMessage'
import { INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage/constants'
import { Typography } from 'transfix-ui/core'
import * as Types from 'apps/fleet-planner/types'

interface IShareLoadSmsEnabledAlertProps {
  settings: Types.DriverSettingsType | undefined
  isExternal?: boolean
  shipmentSMSEnabled?: boolean
}

export const ShareLoadSmsEnabledAlert = memo<IShareLoadSmsEnabledAlertProps>(
  ({ isExternal, settings, shipmentSMSEnabled }) => {
    const { smsStatusUpdatesEnabled } = settings || {}
    const showAlert = (shipmentSMSEnabled || smsStatusUpdatesEnabled) && !isExternal
    return (
      <>
        {showAlert && (
          <div className='mb6 mt2'>
            <InlineMessage
              message={
                <div>
                  <Typography variant='body2'>
                    Driver already has SMS prompts enabled and is already receiving updates.
                  </Typography>
                </div>
              }
              type={INLINE_MESSAGE_VARIANTS.INFO}
            />
          </div>
        )}
      </>
    )
  }
)
